import React, { lazy, memo, Suspense } from "react";
import Loading from "@genericComponents/Loading.js";
const DataHTMLControl = lazy(
  () => import("@controls/DataEntry/DataHTML/DataHTMLControl.js"),
);
const DataHTML = ({
  state,
  tran,
  required,
  name,
  className,
  defaultnone,
  maxLength,
}) => {
  return (
    <Suspense fallback={<Loading />}>
      <DataHTMLControl
        state={state}
        tran={tran}
        required={required}
        name={name}
        className={className}
        defaultnone={defaultnone}
        maxLength={maxLength}
      />
    </Suspense>
  );
};
export default memo(DataHTML);
